import { Routes, Route, useLocation } from "react-router-dom"
import { useEffect } from "react"
import { AnimatePresence, motion } from "framer-motion"
import { Home } from "./pages/Home"
import { Header } from "./shared/components/Header"
import { Footer } from "./shared/components/Footer"
import { OurClient } from "./pages/OurClient"
import { FQA } from "./pages/FQA"
import { AboutUs } from "./pages/AboutUs"
import { pageTransition } from "./shared/lib/motion"
import { PrivacyPolicy } from "./pages/PrivacyPolicy"
import { TermsConditions } from "./pages/TermsConditions"
import { DownloadApp } from "./pages/DownloadApp"
import InTheNews from "./pages/InTheNews"
import ContactUs from "./pages/ContactUs"
import Artical from "./pages/Artical"
import { LanguageProvider } from "./shared/context/LanguageContext"

export default function App() {
  const location = useLocation()
  const isArticlePath = location.pathname.startsWith("/financial-wellness-tips-saudi-employees-2025/")

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" })
  }, [location.pathname])

  return (
    <LanguageProvider>
      <div className="min-h-screen page-enter">
        {location.pathname !== "/form" && <Header />}
        <div className="sm:hidden sticky top-0 left-0 w-full h-[20.5px] bg-white z-50"></div>
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            variants={pageTransition}
            initial="hidden"
            animate="show"
            exit="exit"
          >
            <Routes location={location}>
              <Route path="/" element={<Home />} />
              <Route path="/our-client" element={<OurClient />} />
              <Route path="/faq" element={<FQA />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
              <Route path="/d" element={<DownloadApp />} />
              <Route path="/in-the-news" element={<InTheNews />} />
              <Route path="/form" element={<ContactUs />} />
              <Route path="/financial-wellness-tips-saudi-employees-2025/:lang" element={<Artical />} />
            </Routes>
          </motion.div>
        </AnimatePresence>
        {location.pathname !== "/d" && location.pathname !== "/form" && !isArticlePath && <Footer />}
      </div>
    </LanguageProvider>
  )
}

